import { Link } from 'react-router-dom';

const TestimonialsSection = () => {
  const testimonials = [
    {
      rating: 5,
      title: 'Excellent Service',
      text: 'Smart Heatplumb installed our new heating system quickly and professionally. The team was courteous, clean, and the quality of work exceeded our expectations. Highly recommend!',
      name: 'Michael O\'Sullivan',
      location: 'Killarney, Kerry',
      avatar: 'MO',
    },
    {
      rating: 5,
      title: 'Professional Team',
      text: 'Had an emergency plumbing issue on a Sunday evening. They responded within an hour and fixed the problem efficiently. Great service and fair pricing. Will definitely use again.',
      name: 'Sarah Murphy',
      location: 'Tralee, Kerry',
      avatar: 'SM',
    },
    {
      rating: 5,
      title: 'Bathroom Renovation',
      text: 'Our bathroom looks amazing! The team handled everything from design to installation. They were punctual, professional, and cleaned up after themselves every day. Fantastic work!',
      name: 'Patrick Fitzgerald',
      location: 'Kenmare, Kerry',
      avatar: 'PF',
    },
    {
      rating: 5,
      title: 'Heat Pump Installation',
      text: 'Very impressed with the heat pump installation. The technicians explained everything clearly and the system works perfectly. Energy bills have already decreased significantly.',
      name: 'Emma Collins',
      location: 'Killarney, Kerry',
      avatar: 'EC',
    },
    {
      rating: 5,
      title: 'Reliable & Trustworthy',
      text: 'Been using Smart Heatplumb for all our plumbing needs for over two years. Always reliable, professional, and reasonably priced. They\'re our go-to for any heating or plumbing work.',
      name: 'John McCarthy',
      location: 'Dingle, Kerry',
      avatar: 'JM',
    },
    {
      rating: 5,
      title: 'Underfloor Heating',
      text: 'The underfloor heating installation transformed our home. The process was smooth, the team was knowledgeable, and the results are incredible. Our house has never been more comfortable!',
      name: 'Claire O\'Brien',
      location: 'Killarney, Kerry',
      avatar: 'CO',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-3">
            <div className="w-2 h-2 bg-accent rounded-full"></div>
            <p className="text-accent text-sm font-semibold uppercase tracking-wider">
              CUSTOMER FEEDBACK
            </p>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
            What Our Kerry Clients Say
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Don't just take our word for it. Read what our satisfied customers across Kerry have to say about our plumbing and heating services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Link
              key={index}
              to="/testimonials"
              className="bg-white rounded-xl p-8 border border-gray-100 hover:shadow-lg transition-shadow duration-300 block cursor-pointer"
            >
              {/* Stars */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent text-lg"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-primary mb-3">
                {testimonial.title}
              </h3>

              {/* Review Text */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {testimonial.text}
              </p>

              {/* User Info */}
              <div className="flex items-center space-x-3 pt-6 border-t border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-full flex-shrink-0">
                  <span className="text-accent font-semibold text-sm">
                    {testimonial.avatar}
                  </span>
                </div>
                <div>
                  <p className="text-primary font-semibold text-sm">
                    {testimonial.name}
                  </p>
                  <p className="text-gray-500 text-xs">{testimonial.location}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;